import styled from "styled-components"

interface StyledProps {
  length: number
  small?: boolean
}

const handleLengthType = (length: number, small: boolean) => {
  if (small) {
    switch (length) {
      case 1:
        return "34px"
      case 2:
        return "28px"
      default:
        return "20px"
    }
  }
  switch (length) {
    case 1:
      return "52px"
    case 2:
      return "40px"
    default:
      return "30px"
  }
}

export const Percentage = styled.div<StyledProps>`
  position: absolute;
  right: ${({length, small}) => handleLengthType(length, small)};
  top: ${({small}) => (small ? 45 : 65)}px;
  font-size: 16px;
  span {
    font-size: ${({small}) => (small ? 32 : 42)}px;
  }
`

export const RadialWrapper = styled.div`
  position: relative;
  .recharts-radial-bar-background-sector:first-child {
    display: none;
  }
`
